import { ListResponseModel, toQueryString } from ".";
import { Appliance } from "../model/appliance";
import { Leads, LeadsQueryParams, StartSolarRecommendationRequest, StoreProductDetail } from "../model/leads/leads";
import { AssessmentApplianceSubmissionModel, ScheduleLoadAssessmentPayload } from "../pages/provider/request/request.type";
import { apiSlice } from "../stores/base/api-slice";

// service for admin leads and provider reques  ts
const baseUrl = `${process.env.REACT_APP_SERVER_URL}`;
const createQueryString = (params: LeadsQueryParams) => {
	let queryString = "";

	if (params.page !== undefined) {
		queryString += `page=${params.page}&`;
	}

	if (params.pageSize !== undefined) {
		queryString += `pageSize=${params.pageSize}&`;
	}

	if (params.statuses && params.statuses.length > 0) {
		params.statuses.forEach(status => {
			queryString += `Statuses=${status}&`;
		});
	}

	if (params.CompanyIds && params.CompanyIds.length > 0) {
		params.CompanyIds.forEach(companyId => {
			queryString += `CompanyIds=${companyId}&`;
		});
	}

	return queryString.endsWith("&") ? queryString.slice(0, -1) : queryString;
};

const leadsEndpoint = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getLeads: builder.query<ListResponseModel<Array<Leads>>, LeadsQueryParams>({
			query: params => ({
				url: `${baseUrl}/solar-recommendation/page?${createQueryString(params)}`,
				method: "GET",
				baseUrl: "",
			}),
			providesTags: ["Leads"],
		}),
		getSystemRecommendedProducts : builder.query<StoreProductDetail[], string>({
			query: recommendationId => ({
				url: `/product/solar-recommendation/recommend-products/${recommendationId}`,
				method: "GET",
				baseUrl: "",
			}),
			providesTags: ["Leads-Recommended-Products"]
		}),
		getRequestById: builder.query<Leads, string>({
			query: recommendationId => ({
				url: `${baseUrl}/solar-recommendation/${recommendationId}`,
				method: "GET",
				baseUrl: "",
			}),
			providesTags: ["Recommendation-Request"]
		}),
		getRequest: builder.query<ListResponseModel<Array<Leads>>, LeadsQueryParams>({
			query: params => ({
				url: `${baseUrl}/solar-recommendation/company/page?${createQueryString(params)}`,
				method: "GET",
				baseUrl: "",
			
			}),
			providesTags: ["Recommendation-Requests"],
		}),
		assignProvider: builder.mutation<any, { recommendationId: string; providerId: string }>({
			query: body => ({
				url: `/product/solar-recommendation/select-provider`,
				method: "POST",
				body,
			}),
			invalidatesTags: ["Leads"],
		}),
		recommendNoProducts: builder.mutation<string, { recommendationId: string }>({
			query: (body) => ({
			  url: `/product/solar-recommendation/no-products`,
			  method: "POST",
			  body,
			}),
			invalidatesTags: ["Leads","Recommendation-Request", "Leads-Recommended-Products"],
		  }),
		  recommendProducts: builder.mutation<string, { recommendationId: string; productIds: string[] }>({
			query: body => ({
			  url: `/product/solar-recommendation/accept-recommendation`,
			  method: "POST",
			  body,
			}),
			invalidatesTags: ["Leads"],
		  }),
		  sendCustomerProducts: builder.mutation<string, { recommendationId: string; products: string[] }>({
			query: body => ({
			  url: `/product/solar-recommendation/send-products`,
			  method: "POST",
			  body,
			}),
			invalidatesTags: ["Leads", "Leads-Recommended-Products", "Recommendation-Request"],
		  }),
		  choosePhysicalLoadAssessment: builder.mutation<string, { recommendationId: string }>({
			query: body => ({
			  url: `/product/solar-recommendation/start-physical-load-assesment`,
			  method: "POST",
			  body,
			}),
			invalidatesTags: ["Leads", "Leads-Recommended-Products", "Recommendation-Request"],
		  }),
		  carryOutPhysicalLoadAssessment: builder.mutation<string, AssessmentApplianceSubmissionModel>({
			query: body => ({
			  url: `/product/solar-recommendation/carry-out-physical-load-assessment`,
			  method: "POST",
			  body,
			}),
			invalidatesTags: ["Leads", "Leads-Recommended-Products", "Recommendation-Request"],
		  }),
		  schedulePhysicalLoadAssessment: builder.mutation<any, ScheduleLoadAssessmentPayload>({
			query: body => ({
			  url: `/product/solar-recommendation/schedule-physical-load-assessment`,
			  method: "POST",
			  body,
			}),
			invalidatesTags: ["Leads", "Leads-Recommended-Products", "Recommendation-Request"],
		  }),
		  reSchedulePhysicalLoadAssessment: builder.mutation<any, ScheduleLoadAssessmentPayload>({
			query: body => ({
			  url: `/product/solar-recommendation/reschedule-physical-load-assessment`,
			  method: "POST",
			  body,
			}),
			invalidatesTags: ["Leads", "Leads-Recommended-Products", "Recommendation-Request"],
		  }),
		  saveContinueAssessment: builder.mutation<any, AssessmentApplianceSubmissionModel>({
			query: body => ({
				url: `/product/solar-recommendation/save-continue`,
				method: "POST",
				body,
			}),
			invalidatesTags: ["Leads", "Leads-Recommended-Products", "Recommendation-Request"],
		}),
		startSolarRecommendation: builder.mutation<any, StartSolarRecommendationRequest>({
			query: body => ({
				url: `/product/solar-recommendation/start`,
				method: "POST",
				body,
			}),
			invalidatesTags: ["Leads"],
		}),
	}),
});

export const { useGetLeadsQuery,
	           useGetRequestByIdQuery,
	           useLazyGetRequestQuery,
	           useGetRequestQuery,
			   useAssignProviderMutation,
			   useRecommendNoProductsMutation,
			   useRecommendProductsMutation,
			   useSendCustomerProductsMutation,
			   useCarryOutPhysicalLoadAssessmentMutation,
			   useChoosePhysicalLoadAssessmentMutation,
			   useGetSystemRecommendedProductsQuery,
			   useSchedulePhysicalLoadAssessmentMutation,
			   useReSchedulePhysicalLoadAssessmentMutation,
			   useSaveContinueAssessmentMutation,
			   useStartSolarRecommendationMutation
				 } = leadsEndpoint;
